export default __webpack_public_path__ + "static/media/NYAC.ee9cf3e5.png";